// extracted by mini-css-extract-plugin
export var alertIcon = "_qm-0";